<template>
  <div class="table">
    <div class="table-header">
      <div class="table-header-cell date">
        {{ $t('Date') }}
      </div>
      <div class="table-header-cell txn">
        {{ $t('Txn') }}
      </div>
      <div class="table-header-cell bet">
        {{ $t('Total') }}
      </div>
    </div>
    <div class="table-body">
      <div v-for="(ticket, index) in ticketsDisplay" :key="index">
        <div
          class="total-general table-row"
          :class="{ even: (index + 1) % 2 === 0 }"
          @click.stop="collapseToggle(index)"
        >
          <div class="table-cell date">
            <span>{{ ticket.date }}</span>
          </div>
          <div class="txn">{{ ticket.txn || '-' }}</div>
          <div
            class="table-cell bet"
            :class="{ win: ticket.total > 0, lose: ticket.total < 0, selected: isRowUnCollapse(index) }"
          >
            {{ `${currencySymbol} ${formatAmount(ticket.total)}` }}
          </div>
        </div>
        <Transition>
          <div v-if="isRowUnCollapse(index)" class="total-details table-row" :class="{ even: (index + 1) % 2 === 0 }">
            <div class="table-cell jackpot">
              <span class="total-header">{{ $t('Jackpot') }}</span>
              <span :class="{ win: ticket.jackpot > 0, lose: ticket.jackpot < 0 }">{{
                Number(ticket.jackpot) ? `${currencySymbol} ${formatAmount(ticket.jackpot)}` : '-'
              }}</span>
            </div>
            <div class="table-cell ante">
              <span class="total-header"> {{ $t('Ante') }}</span>
              <span :class="{ lose: Number(ticket.ante) }">{{
                Number(ticket.ante) ? `${currencySymbol} -${formatAmount(ticket.ante)}` : '-'
              }}</span>
            </div>
            <div class="table-cell commission">
              <span class="total-header">{{ $t('Commission') }} </span>
              {{ Number(ticket.commission) ? `${currencySymbol} ${formatAmount(ticket.commission)}` : '-' }}
            </div>
            <div class="table-cell wl-total">
              <span class="total-header">W/L</span>
              <span :class="{ win: ticket.wl > 0, lose: ticket.wl < 0 }">{{
                Number(ticket.wl) ? `${currencySymbol} ${formatAmount(ticket.wl)}` : '-'
              }}</span>
            </div>
          </div>
        </Transition>
      </div>
      <div class="table-row total-amount" :class="{ even: (ticketsDisplay.length + 1) % 2 === 0 }">
        <div class="table-cell">
          {{ $t('Total') }}
        </div>
        <div class="table-cell" :class="{ win: overallTotal > 0, lose: overallTotal < 0 }">
          {{ `${currencySymbol} ${formatAmount(overallTotal)}` }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { generateStatementData, formatAmount } from '@/utils/helpers';
import { findIndex } from 'lodash';

export default {
  data: () => {
    return {
      overallTotal: 0,
      uncollapseRows: [],
    };
  },
  computed: {
    ...mapGetters({
      ticketTotals: 'ticket/ticketTotals',
      member: 'general/member',
      timezone: 'general/timezone',
    }),
    currencySymbol() {
      return this.member.currencySymbol;
    },
    ticketsDisplay() {
      const { data, total } = generateStatementData(this.ticketTotals, this.$moment, this.timezone);
      this.overallTotal = total;
      return data.filter((d) => d.txn !== 0).reverse();
    },
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    ...mapActions('ticket', ['resetTicket', 'updateTicket']),
    formatAmount,
    isRowUnCollapse(index) {
      return this.uncollapseRows.includes(index);
    },
    collapseToggle(index) {
      if (this.uncollapseRows.includes(index)) {
        const itemIndexInArr = findIndex(this.uncollapseRows, index);
        this.uncollapseRows.splice(itemIndexInArr, 1);
      } else {
        this.uncollapseRows.push(index);
      }
    },
    resetCollapse() {
      this.uncollapseRows = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
  
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  height: auto;

  &-header {
    height: 32px;
    width: 100%;
    padding: 6px 32px 6px 16px;
    box-sizing: border-box;
    background-color: #52402a;
    display: flex;
    flex-direction: row;
    align-items: center;

    &-cell {
      line-height: 1.27;
      letter-spacing: normal;
      color: #ceb57d;
      text-transform: uppercase;
      text-align: left;
    }
  }

  &-body {
    height: 100%;
  }

  &-row {
    padding: 0 32px 0 16px;
    box-sizing: border-box;
    height: 48px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: uppercase;
    cursor: pointer;
    background: transparent;
    &.even {
      @include background-opacity(#3c3a37, 0.4);
    }
    .table-cell {
      &.result {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .bet {
    width: 20%;
    text-align: right;

    img {
      height: 12px;
      width: 12px;
    }

    .tax {
      font-size: 10px;
      color: #6a91a7;
      margin-top: 4px;
    }
  }

  .odds {
    width: 15%;
    text-align: right;
  }
  .win {
    color: #44f589;
  }
  .lose {
    color: #e85050;
  }
  .wl {
    width: 25%;
    text-align: right;
    text-transform: capitalize;

    .result-status {
      height: 20px;
      padding: 4px 6px;
      border-radius: 4px;
      text-transform: uppercase;
      font-weight: 600;
    }
    .cancelled {
      color: #6c6030;
      background-color: #d8c7a0;
    }
    .void {
      background-color: #3c3a37;
    }
    .draw {
      background-color: #1fa052;
    }
  }
  .total-general {
    .table-cell {
      &.bet {
        position: relative;
        &::after {
          content: '';
          display: block;
          width: 6px;
          height: 6px;
          margin: 8px 0 8px 8px;
          transform: rotate(135deg);
          -webkit-transform: rotate(135deg);
          transition: all 0.1s ease-in;
          border: 2px solid #d8c7a0;
          border-bottom: none;
          border-left: none;
          position: absolute;
          top: -8px;
          right: -20px;
        }
        &.selected {
          &::after {
            -ms-transform: rotate(-45deg);
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            transition: all 0.1s ease-in;
            transform-origin: 100% 100%;
          }
        }
      }
    }
  }
  .total-details {
    display: flex;
    justify-content: space-between;

    .table-cell {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  .total-header {
    color: #6a91a7;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.2;
  }

  .wl-total {
    flex: 2;
    text-align: right;
  }
  .date {
    display: flex;
    flex-direction: column;
    width: 60%;
    color: #ceb57d;
    &-details {
      font-size: 10px;
      line-height: 1.2;
    }
  }
  .txn {
    width: 20%;
  }
  .total-amount {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
